import { Repository, EntityRepository } from 'typeorm';
import { IndentItemEntity } from '../indent-item-entity';


@EntityRepository(IndentItemEntity)
export class IndentItemRepository extends Repository<IndentItemEntity>{

    
    
}
